import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyContentView from '../../views/fullBodyContentView';

function ProcessVariable({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit});
    });
  }, [onExit]);
  return (
    <FullBodyContentView
      title="View Process Variables"
      fullCaption="Mass Flow Rate.........0.0f gram/s.....
      Volume Flow Rate......0.0f L/s..........
      GSV Flow Rate..........//fastlF*/..........
      Temperature..............29°C................
      Density......................1 g/cm3........... 
      Referred Density........0.0f g/cm3..... 
      Referred Volume Flow......0.0f L/s..........
      Average Line Density........0.0f g/cm3.....
      Average Temperature.........0.0f °C.....
      CTPL....................0.0f......
      Specific Gravity....................0.0f......
      Standard Vol Flow......0.0f L/s..........
      Net Mass Flow........0.0f gram/s.....
      Net Volume Flow Rate......0.0f L/s..........
      Concentration..................0.0f......
      Baume..................0.0f......
      Mass Fwd Total.............0..........
      Vol Fwd Total.............0..........
      CorrVol Fwd Total............0..........
      GasVol Fwd Total............0..........
      StdVol Fwd Total............0..........
      NetMass Fwd Total............0..........
      NetVol Fwd Total............0..........
      Mass Fwd Inv............0..........
      Vol Fwd Inv............0..........
      CorrVol Fwd Inv............0..........
      GasVol Fwd Inv............0..........
      StdVol Fwd Inv............0..........
      NetMass Fwd Inv............0..........
      NetVol Fwd Inv............0..........
      Phase............0..........
      External Pressure................0.0f psi......
      External Temperature.........0.0f °C.....
      Flow Rate Switch........Off......
      NetOilFlow @ Line...................0.0f......
      Watercut @ Line............0..........
      External Water Cut...................0.0f......
      NetWaterFlow @ Line...................0.0f......
      NetOilFlow @ Ref...................0.0f......
      Watercut @ Ref............0..........
      NetWaterFlow @ Ref...................0.0f......
      DensOil @ Line (degAPI)...................0.0f......
      Gas Void Fraction...................0.0f......
      Unremediated Mass Flow..........//fastlF*/..........
      Unremediated Vol Flow..........//fastlF*/..........
      Unremediated Density..........//fastlF*/..........
      External Density......1.0 g/cm3......
      Liquid Mass Flow..........//fastlF*/..........
      Calorific Value..................0.0f......
      Energy Flow..................0.0f......

      "
    />
  );
}

export default ProcessVariable;
